<template>
                <div class="news-items mt54">
                    
                    <a href="https://mp.weixin.qq.com/s/m9dDIaxdjQN_jp8MX4JsAg" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible; animation-name: com-animate;">
                        <div class="pic"><img src="@/assets/images/1688545062656467.jpg" alt="共创数字未来，鲁澳合资公司融贯云洲签约成立！" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/30<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">共创数字未来，鲁澳合资公司融贯云洲签约成立！</div>
                                <div class="desc">2023港澳山东周于5月29日至6月2日在香港、澳门如期举行，主题为“深化合作 共创未来”。30日上午，山东省高质量发展开放合作推介会在香港举行，贯彻落实习近平总书记关于深化内地与港澳互利合作的重要指示精神。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/h7pJNw4VzUakhYa7BgKUdA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible; animation-name: com-animate;">
                        <div class="pic"><img src="@/assets/images/1688544718744536.png" alt="澳门融贯应邀参加国际化标准大会，标准数字化助力高质量发展" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/26<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">澳门融贯应邀参加国际化标准大会，标准数字化助力高质量发展</div>
                                <div class="desc">5月26日，由珠海格力电器股份有限公司、合肥通用机械研究院、中国制冷空调工业协会共同主办的2023珠海·国际标准化大会（以下简称大会）在珠海举行，澳门融贯受邀参加。广东省市场监督管理局、珠海市人民政府为大会指导单位，珠海市市场监督管理局、中国制冷学会、中国WTO/TBT-SPS制冷设备技术贸易措施研究评议基地为大会协办单位。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/6OJNunKOxV5Dnut9fqG91Q" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1688544607652856.jpg" alt="以国家之需，尽澳门所长 融贯国际受邀参加2023粤港澳台青年企业家交流会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/19<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">以国家之需，尽澳门所长 融贯国际受邀参加2023粤港澳台青年企业家交流会</div>
                                <div class="desc">5月17日-19日，由孙中山基金会、香港友好协进会、台湾海峡两岸经贸文化交流协会、澳门青年企业家协会共同主办的“‘天下为公’·中华情——2023粤港澳台青年企业家交流会”在广州召开。开幕式前，全国政协副主席何厚铧发表致辞，会见参会嘉宾和港澳台青年企业家代表。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/bzpSHmENP08sH_W1t7b7bA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1688544206809688.jpg" alt="为澳门数字贸易而建 | 融贯国际BEYOND Expo 2023圆满收官" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/10<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">为澳门数字贸易而建 | 融贯国际BEYOND Expo 2023圆满收官</div>
                                <div class="desc">5月10日-12日，由澳门科技总会主办的第三届BEYOND国际科技创新博览会（简称“BEYOND Expo ”）在澳门威尼斯人金光会展中心如期举行。融贯国际携“星火·链网”国际超级节点（澳门）创新应用亮相BEYOND Expo，链网协同技术为湾区数字经济发展带来的新动能。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/Bf-7s2GyhHyZaCd5QPnwAQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1683524552430762.jpg" alt="陈祥受邀参加2023泰尔英福合作伙伴大会 为澳门数字新时代聚力" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">04/20<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">陈祥受邀参加2023泰尔英福合作伙伴大会 为澳门数字新时代聚力</div>
                                <div class="desc">4月20日，2023泰尔英福合作伙伴大会在上海顺利举办，本次大议以“数字驱动·智能未来”为主题，围绕工业互联网标识和区块链等领域，全面呈现产业生态、行业调研、发展模式等内容，加速推动数字经济高质量发展。融贯国际总经理陈祥作为区块链专题特邀嘉宾出席大会，并发表了《“星火·链网”重构中葡数字贸易》主题演讲。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/o5iHDTFbBP8GheZHFMI3yw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1683524190760736.jpg" alt="科技聚才，澳优码亮相第二十一届中国国际人才交流大会！" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">04/15<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">科技聚才，澳优码亮相第二十一届中国国际人才交流大会！</div>
                                <div class="desc">4月15日，由科学技术部和深圳市人民政府共同主办的第二十一届中国国际人才交流大会在深圳开幕。融贯国际推出的“星火·链网”骨干节点（珠海横琴）创新应用——澳优码亮相粤港澳大湾区展区。融贯国际董事长冯文滔先生接受了来自深圳报业集团视听中心的采访，分享了澳优码应用现状及后续横琴粤澳链关于“人才链”的建设规划。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/w_agZvNaWYJdsC0Mr4O_tg" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1683524010933542.jpg" alt="科技赋能旅游业 澳优码亮相2023山东旅发大会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">03/27<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">科技赋能旅游业 澳优码亮相2023山东旅发大会</div>
                                <div class="desc">近日，澳优码携手百年品牌崂山矿泉水亮相2023年山东省旅游发展大会，开启鲁澳合作新篇章。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/68Kf2Vg-yhM4Hi796CpEtQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1679898979385168.jpg" alt="冯文滔参加“湾区认证”调研座谈会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">03/23<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">冯文滔参加“湾区认证”调研座谈会</div>
                                <div class="desc">3月23日，市场监管总局认证监管司司长刘卫军一行赴广东调研“湾区认证”工作推进情况，澳门质量品牌国际认证联盟理事长冯文滔先生出席会议并致辞，澳门日报对此次座谈活动进行了报道。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>